import { AppState } from "../../../redux-configuration/AppState";
import { SocialPageInfo } from "../../domain/entity/socialPageInfo";

export const findInstagramAccountLoadingSelector = (appState: AppState): boolean => appState.company.findInstagramAccount.loading
export const findInstagramAccountErrorSelector = (appState: AppState): string | undefined => appState.company.findInstagramAccount.error
export const instagramAccountSelector = (appState: AppState): SocialPageInfo[] | null => appState.company.findInstagramAccount.pageInfo
